import isArray from 'lodash/isArray';
import get from 'lodash/get';

const showError = (errorMessage, error) => {
  return errorMessage || (isArray(error) ? get(error, '0', error) : error);
};

export default showError;
